import { ref, Ref } from '@vue/composition-api';

export type ProfileEditVariables = {
  gamertag: Ref<string>;
  profilePic: Ref<File | null>;
  profileCover: Ref<File | null>;
  loading: Ref<boolean>;
  toastyMessage: Ref<string>;
  toastyColor: Ref<string>;
}

export default function useProfileEditVariables(): ProfileEditVariables {
  const gamertag = ref('');
  const profilePic = ref(null);
  const profileCover = ref(null);
  const loading = ref(false);
  const toastyMessage = ref('');
  const toastyColor = ref('error');

  return {
    gamertag,
    profileCover,
    profilePic,
    loading,
    toastyMessage,
    toastyColor,
  };
}
